<template>
  <v-dialog v-model="dialogShowQRCode" persistent max-width="500px">
    <v-card style="border-radius:20px;">
      <v-card tile>
        <v-toolbar card style="background: #1a222c !important;">
          <v-toolbar-title class="white--text CSChatThai" style="white-space: nowrap; width: 100%; overflow: hidden; text-overflow: ellipsis;">
           <span class="headline CSChatThai" >
              <v-icon color="white">fas fa-qrcode</v-icon>&nbsp;&nbsp;{{$t('Settings.Qrcode.header')}}
            </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDialog">
            <v-icon style="color: white !important; font-size: 25px !important;">clear</v-icon>
          </v-btn>
        </v-toolbar>
      </v-card>
      <v-card-text style="margin-top:0vh; margin-bottom:0vh; justify-content: center !important; height: 460px !important;">
        <!-- <v-container grid-list-md> -->
          <v-layout wrap >
            <v-flex sm12 md12 lg12 xl12 >
              <v-tabs centered icons-and-text v-model="active_tab" style=" height: 350px;">
              <v-tabs-slider color="info"></v-tabs-slider>
                <v-tab v-if="type_menu !== 'richmenu'" href="#tab-1" :key="1" style="color: white !important;background: #2562af !important; text-transform: none;" >
                  {{$t('Settings.Qrcode.myQRcode')}}
                  <v-icon style="color: white !important; font-size: 25px !important;">fas fa-qrcode</v-icon>
                </v-tab>
                <v-tab href="#tab-2" :key="2" style="color: white !important;background: #2562af !important;text-transform: none;">
                   {{$t('Settings.Qrcode.scanQRcode')}}
                  <v-icon style="color: white !important; font-size: 25px !important;">mdi-qrcode-scan</v-icon>
                </v-tab>

                <v-tabs-items style="margin-top: 15px;">
                  <v-tab-item id="tab-1">
                     <div >
                      <p style="text-align: center;">
                        <qrcode :value="tokenuserQR" style="margin: 0 !important; height: 220px; width: 220px; padding: 5px; border: 3px solid; border-radius: 10px;" id="downloadqruser">
                        </qrcode>
                      </p>
                      <p>{{$t('Settings.editProfile.detailQRcode')}}
                      <a href="#" class="button" id="btn-download" :download="'qrcode_user_' + name + '.png'" @click="loadqr()">{{$t('AnswerQuestion.download')}}</a></p>
                    </div>
                  </v-tab-item>
                  <v-tab-item id="tab-2">
                    <div>
                      <p class="error">{{ error }}</p>
                      <qrcode-stream id="qrcode-stream" @decode="onDecode" @init="onInit" :camera="camera? 'auto':'off'"/>

                      <qrcode-capture @decode="onDecode" style="display: none !important;" id="qrcode-capture"/>
                    </div>
                    <v-layout v-if="type_menu !== 'richmenu'" row wrap align-center justify-center class="mt-4">
                      <v-btn @click="upfileqrcode()" class="btn-upfileqrcode">{{$t('AnswerQuestion.selectPicture')}}</v-btn>
                    </v-layout>
                  </v-tab-item>
                </v-tabs-items>
              </v-tabs>






            </v-flex>
          </v-layout>
        <!-- </v-container> -->
      </v-card-text>
    </v-card>
      <Openwebsite :dialogopenwebsite="dialogopenwebsite" :id="id" :type="type" @closeDialog="closeDialog"></Openwebsite>
  </v-dialog>
</template>
<script>
import Vue from 'vue'
import { Decode } from '@/services'
import VueQrcode from '@xkeshi/vue-qrcode'
import { QrcodeStream, QrcodeCapture } from 'vue-qrcode-reader'
import Openwebsite from  '@/components/chat/dialog/settings/Openwebsite'
Vue.component(VueQrcode.name, VueQrcode)

export default {
  props: {
    'dialogShowQRCode': false,
    'typemenu': String,
    'tokenroom': String,
    'QrcodeInfor': {}
  },
  data: () => ({
    active_tab: 'tab-1',
    token: '',
    name: '',
    tokenuserQR: '',
    error: '',
    result: '',
    camera: false,
    dialogopenwebsite: false,
    id: '',
    type: '',
    type_menu: ''
  }),
  watch: {
    dialogShowQRCode () {
      this.type_menu = this.typemenu
      if (this.dialogShowQRCode) {
        if (this.typemenu === 'richmenu') {
          this.active_tab = 'tab-2'
          this.camera = true
          // console.log(this.typemenu)
        } else {
          this.active_tab = 'tab-1'
          // console.log(this.typemenu)
        }
      }
    },
    active_tab () {
      // console.log(this.active_tab)
      if (this.active_tab === 'tab-2') {
        this.camera = true
      } else {
        this.camera = false
      }
    }
  },
  methods: {
    upfileqrcode () {
      $('#qrcode-capture').click()
    },
    closeDialog () {
      this.camera = false
      this.dialogopenwebsite = false
      this.result = ''
      this.id = ''
      this.type = ''
      this.$emit('closeShowQRCodeUser', false)
    },
    loadqr () {
      var cnvs = document.getElementById('downloadqruser')
      var button = document.getElementById('btn-download')
      var dataURL = cnvs.toDataURL('image/png')
      button.href = dataURL
    },
    checkonechat (url) {
      if (url.includes(process.env.API + '/qrcode/friend?id=')){
        var code = url.split(process.env.API + '/qrcode/friend?id=')
        this.id = atob(code[1])
        this.type = 'friend'
        this.dialogopenwebsite = true
        this.$emit('closeShowQRCodeUser', false)
      } else if (url.includes(process.env.API + '/qrcode/group?id=')){
        var code = url.split(process.env.API + '/qrcode/group?id=')
        this.id = atob(code[1])
        this.type = 'group'
        this.dialogopenwebsite = true
        this.$emit('closeShowQRCodeUser', false)
      } else {
        this.$emit('closeShowQRCodeUser', false)
        this.$swal({
          text: 'ผลการสแกน ' + url,
          showCancelButton: true,
          confirmButtonColor: '#2562af',
          cancelButtonColor: '#9f9f9f',
          confirmButtonText: 'เปิด',
          cancelButtonText: 'ยกเลิก',
          buttonsStyling: true,
          showCloseButton: true,
          reverseButtons: true
        }).then((result) => {
          if (result.value) {
            window.open(url)
            this.closeDialog()
          } else {
            this.closeDialog()
          }
        })
      }
    },
    onDecode (result) {
      // console.log(result)
      // console.log(this.type_menu)
      this.result = result
      if (result != '' && this.type_menu !== 'richmenu') {
        this.checkonechat(result)
        this.camera = false
      } else if (this.type_menu === 'richmenu') {
        this.sendScanQrcode(result)
      }
    },
    sendScanQrcode (url) {
      if (this.QrcodeInfor.status === 'false') {
        this.axios.post(process.env.APIalpine + '/api/v1/qrcode-scan', {
          tokenuser: this.token,
          tokenroom: this.tokenroom,
          data: url
        }).then((response) => {
          // console.log(response.data)
          if (response.data.status === 'success') {
            this.$swal('', this.$t('Alert.Success.success'), 'success')
            this.closeDialog()
          }
        }).catch(error => {
          console.log(error)
          this.$swal('Network error', this.$t('Alert.Fail.default.networkError'), 'error')
        })
      } else {
        this.axios.post(process.env.APIQRcodeLoation, {
          tokenuser: this.token,
          tokenroom: this.tokenroom,
          data: url,
          lat: this.QrcodeInfor.lat,
          long: this.QrcodeInfor.lng,
          address: this.QrcodeInfor.address
        }).then((response) => {
          // console.log(response.data)
          if (response.data.status === 'success') {
            this.$swal('', this.$t('Alert.Success.success'), 'success')
            this.closeDialog()
          }
        }).catch(error => {
          console.log(error)
          this.$swal('Network error', this.$t('Alert.Fail.default.networkError'), 'error')
        })
      }
    },
    async onInit (promise) {
      try {
        await promise
      } catch (error) {
        if (error.name === 'NotAllowedError') {
          this.error = "ERROR: you need to grant camera access permisson"
        } else if (error.name === 'NotFoundError') {
          this.error = "ERROR: no camera on this device"
        } else if (error.name === 'NotSupportedError') {
          this.error = "ERROR: secure context required (HTTPS, localhost)"
        } else if (error.name === 'NotReadableError') {
          this.error = "ERROR: is the camera already in use?"
        } else if (error.name === 'OverconstrainedError') {
          this.error = "ERROR: installed cameras are not suitable"
        } else if (error.name === 'StreamApiNotSupportedError') {
          this.error = "ERROR: Stream API is not supported in this browser"
        }
      }
    }
  },
  components: {
    QrcodeStream,
    Openwebsite,
    QrcodeCapture
  },
  created () {
    this.name = localStorage.getItem('name')
    var decoded =  JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    this.token = decoded['tokenuser']
    this.tokenuserQR = process.env.APIQRcode + '/qrcode/friend?id=' + btoa(this.token)
  }
}
</script>
<style type="text/css" scoped>
.btn-upfileqrcode {
  border-radius: 30px !important;
  width: 180px !important;
  background-color: #2561b0 !important;
  color: white !important;
  height: 35px !important;
  text-transform: none;
}
.CSChatThai {
 font-family: 'CS ChatThaiUI' !important;
 word-wrap: break-word;
}
.v-tabs__bar {
    background-color: #ffffff;
}
>>>.camera[data-v-1f90552a] {
  height: 260px;
}
</style>



// WEBPACK FOOTER //
// src/components/chat/dialog/settings/ShowQRCodeUserDialog.vue